import React from "react";
import { Link } from "react-router-dom";

function InnerTitle2({ title }) {
  return (
    <section className="page-title-bg m-[15px] bg-primary-50 rounded-[20px] py-8 md:py-12">
      <div className="container">
        <div className="flex items-center justify-between flex-col gap-[15px]">
          <h1 className="heading-web-h1">{title}</h1>
          <ul className="flex items-center gap-[15px] m-0 p-0">
            <li>
              <Link
                to="/"
                className="headings-h6 text-primary-400 hover:!text-[var(--primary-600)] !no-underline"
              >
                Home
              </Link>
            </li>
            <li>
              <span className="bg-primary-400 w-[8px] h-[8px] rounded-full inline-block"></span>
            </li>
            <li>
              <span className="body-lg text-[var(--black-scale-900)]">
                {title}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default InnerTitle2;
